import { apiClients } from '../config/apiClient';

/**
 * API para manejo de cuotas de usuario
 */
export const userQuotaAPI = {
  /**
   * Obtener información de la cuota del usuario actual
   * @returns {Promise<Object>} Información de la cuota
   */
  async getUserQuota() {
    try {
      const response = await apiClients.extraction.get('/user/quota');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Error al obtener información de cuota',
        statusCode: error.response?.status || 500
      };
    }
  },

  /**
   * Verificar si el usuario tiene suficientes documentos en su cuota
   * @param {number} documentsNeeded Cantidad de documentos necesarios
   * @returns {Promise<Object>} Resultado de la verificación
   */
  async checkQuotaSufficient(documentsNeeded) {
    try {
      const response = await apiClients.extraction.post('/user/quota/check', {
        documents_needed: documentsNeeded
      });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Error al verificar cuota',
        statusCode: error.response?.status || 500
      };
    }
  },

  /**
   * Agregar documentos a la cuota de un usuario (solo admin)
   * @param {number} userId ID del usuario
   * @param {number} documents Cantidad de documentos a agregar
   * @returns {Promise<Object>} Resultado de la operación
   */
  async addQuota(userId, documents) {
    try {
      const response = await apiClients.users.post(`/admin/${userId}/add-quota`, {
        documents_to_add: documents
      });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Error al agregar cuota',
        statusCode: error.response?.status || 500
      };
    }
  },

  /**
   * Formatear información de cuota para mostrar en la UI
   * @param {Object} quota Objeto de cuota del backend
   * @returns {Object} Información formateada
   */
  formatQuotaInfo(quota) {
    if (!quota) {
      return {
        available: 0,
        used: 0,
        total: 0,
        percentage: 0,
        status: 'unknown'
      };
    }

    const available = quota.available_documents || 0;
    const used = quota.used_documents || 0;
    const total = available + used;
    const percentage = total > 0 ? Math.round((used / total) * 100) : 0;

    let status = 'healthy';
    if (available <= 10) status = 'critical';
    else if (available <= 50) status = 'low';

    return {
      available,
      used,
      total,
      percentage,
      status,
      lastUpdated: quota.last_updated || new Date().toISOString()
    };
  }
};

export default userQuotaAPI;
